import { Store, Module, ActionContext } from "vuex";
import ListModule from "./list-module";
import ListState from "./list-state";
import User from "../entities/user";
import Role from "../entities/role";
import Client from "../entities/clientForSelect";
import Ajax from "../../lib/ajax";
import PageResult from "@/store/entities/page-result";
import ListMutations from "./list-mutations";
import Warehouse from "../entities/warehouseForSelect";

interface UserState extends ListState<User> {
  editUser: User;
  roles: Role[];
  clients: Client[];
  warehouses: Warehouse[];
  employees: User[];
}
class UserMutations extends ListMutations<User> {}
class UserModule extends ListModule<UserState, any, User> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<User>(),
    loading: false,
    editUser: new User(),
    roles: new Array<Role>(),
    clients: new Array<Client>(),
    warehouses: new Array<Warehouse>(),
    employees: new Array<User>(),
  };
  actions = {
    async getAll(context: ActionContext<UserState, any>, payload: any) {
      context.state.loading = true;
      let reponse = await Ajax.get("/api/services/app/User/GetAll", {
        params: payload.data,
      });
      context.state.loading = false;
      let page = reponse.data.result as PageResult<User>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async create(context: ActionContext<UserState, any>, payload: any) {
      await Ajax.post("/api/services/app/User/Create", payload.data);
    },
    async update(context: ActionContext<UserState, any>, payload: any) {
      await Ajax.put("/api/services/app/User/Update", payload.data);
    },
    async delete(context: ActionContext<UserState, any>, payload: any) {
      await Ajax.delete("/api/services/app/User/Delete?Id=" + payload.data.id);
    },
    async get(context: ActionContext<UserState, any>, payload: any) {
      let reponse = await Ajax.get(
        "/api/services/app/User/GetDetail?Id=" + payload.data.id
      );
      return reponse.data.result; // as User;
    },
    async getRoles(context: ActionContext<UserState, any>) {
      let reponse = await Ajax.get("/api/services/app/User/GetRoles");
      context.state.roles = reponse.data.result.items as Role[];
    },
    async changeLanguage(context: ActionContext<UserState, any>, payload: any) {
      await Ajax.post("/api/services/app/User/ChangeLanguage", payload.data);
    },
    async getClients(context: ActionContext<UserState, any>) {
      let reponse = await Ajax.get(
        "/api/services/app/Client/GetClientsForSelect"
      );
      context.state.clients = reponse.data.result.items as Client[];
    },
    async getWarehouses(context: ActionContext<UserState, any>) {
      let reponse = await Ajax.get(
        "/api/services/app/Warehouse/GetWarehousesForSelect"
      );
      context.state.warehouses = reponse.data.result.items as Warehouse[];
    },
    async getEmployeesInWarehouse(context: ActionContext<UserState, any>) {
      let reponse = await Ajax.get(
        "/api/services/app/User/GetEmployeesOfWarehouse"
      );
      context.state.employees = reponse.data.result as User[];
    },
    async resetUserPassword(
      context: ActionContext<UserState, any>,
      payload: any
    ) {
      await Ajax.put("/api/services/app/User/ResetPassword", payload.data);
    },
    async changePassword(context: ActionContext<UserState, any>, payload: any) {
      await Ajax.put("/api/services/app/User/ChangePassword", payload.data);
    },
    async unlockUser(context: ActionContext<UserState, any>, payload: any) {
      await Ajax.put("/api/services/app/User/UnlockUser", payload.data);
    },
    async searchForSelect(
      context: ActionContext<UserState, any>,
      payload: any
    ) {
      const {
        data: { result },
      } = await Ajax.get("/api/services/app/User/GetForSelect", {
        params: payload.data,
      });
      return result.items;
    },
    async uploadAvatar(context: ActionContext<UserState, any>, data: any) {
      const {
        data: { result },
      } = await Ajax.post("/api/services/app/User/UploadAvatar", data);
      return result;
    },
    async getDepartmentForSelect(
      context: ActionContext<UserState, any>,
      payload: any
    ) {
      let reponse = await Ajax.get(
        "/api/services/app/Department/GetForSelect",
        { params: payload.data }
      );
      return reponse.data.result.items;
    },
    async getTitleForSelect(
      context: ActionContext<UserState, any>,
      payload: any
    ) {
      let result = await Ajax.get(`api/services/app/Title/GetForSelect`, {
        params: payload.data,
      });
      return result.data.result.items;
    },
    async changeNotificationToRead(
      context: ActionContext<UserState, any>,
      payload: any
    ) {
      await Ajax.put(
        `/api/services/app/User/${payload.data.id}/read-notification`
      );
    },
    async searchEmployeesOfWarehouse(
      context: ActionContext<UserState, any>,
      payload: any
    ) {
      let reponse = await Ajax.get(
        "/api/services/app/User/SearchEmployeesOfWarehouse",
        {
          params: payload.data,
        }
      );
      return reponse.data.result;
    },
    async searchEmployeesOfClient(
      context: ActionContext<UserState, any>,
      payload: any
    ) {
      let reponse = await Ajax.get(
        "/api/services/app/User/SearchEmployeesOfClient",
        {
          params: payload.data,
        }
      );
      return reponse.data.result;
    },
  };
  mutations = {
    setCurrentPage(state: UserState, page: number) {
      state.currentPage = page;
    },
    setPageSize(state: UserState, pagesize: number) {
      state.pageSize = pagesize;
    },
    edit(state: UserState, user: User) {
      state.editUser = user;
    },
  };
}
const userModule = new UserModule();
export default userModule;
